import React from 'react'
import ServiceSingle from '../components/ServiceSingle'

const HearingTest = () => {
  return (
    <>
  <ServiceSingle
  ServiceImg="./images/hearing.png" 
  ServiceName='Hearing Test'
  ServiceText='Hearing test provides a measurement of the sensitivity of a person’s hearing across the full range of speech. The test will measure the quietest sound that can be heard several points across the speech range – this hearing test is termed an audiogram PTA.'
  />
    </>
  )
}

export default HearingTest